<template>
  <div class="main_right">
    <div class="Box">
      <!-- 选择 -->
      <el-date-picker
          v-model="value1"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          @change="handleDateChange"
          placeholder="选择日期">
      </el-date-picker>
      <div class="testpage" style="height:calc(100% - 6.5vw);">
        <p>
          <span>课后复习</span>
        </p>
        <el-table ref="table" class="table" :data="tableData" border
                  :header-cell-style="{background:'#F1F8FF',color:'#333','text-align':'center'}">
          <!-- 自定义序号 -->
          <el-table-column align="center" width="80" label="序号">
            <template v-slot="scope">
              {{ (pages.currentPage - 1) * pages.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>

          <el-table-column prop="xsxm" align="center" show-overflow-tooltip label="学生姓名"/>
          <el-table-column prop="dcsl" align="center" show-overflow-tooltip label="复习单词数量"/>
          <el-table-column prop="sucs" align="center" show-overflow-tooltip label="熟词数"/>
          <el-table-column prop="jscs" align="center" show-overflow-tooltip label="夹生词数"/>
          <el-table-column prop="shcs" align="center" show-overflow-tooltip label="生词数"/>
          <el-table-column prop="wzws" align="center" show-overflow-tooltip label="未掌握数"/>
          <el-table-column prop="yzws" align="center" show-overflow-tooltip label="已掌握数"/>
        </el-table>
      </div>
      <div class="page">
        <el-pagination @size-change="stuHandleSizeChange" @current-change="stuHandleCurrentChange"
                       :current-page="pages.currentPage" :page-sizes="[10, 20, 30, 40]"
                       :page-size="pages.pageSize" layout="total, sizes, prev, pager, next"
                       :total="pages.total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>
<script>
import {queryReview} from '@/api/student'

export default {
  data() {
    return {
      value1: this.formatDate(new Date()),
      pages: {
        currentPage: 1,
        pageSize: 10,
        total: 100
      },
      tableData: []
    }
  },
  created() {
    this.getReview(this.value1)
  },

  methods: {
    formatDate(date) {
      const d = new Date(date);
      const year = d.getFullYear();
      const month = (d.getMonth() + 1).toString().padStart(2, '0');
      const day = d.getDate().toString().padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    handleDateChange(date) {
      this.getReview(date)
    },
    // 获取熟词信息
    async getReview(date) {
      const {result: {list, total}, resultCode} = await queryReview({
        currentPage: this.pages.currentPage,
        pageSize: this.pages.pageSize,
        fxrq: date,
        xsid: this.$store.state.userInfo.yhid,
      })
      if (resultCode === 200) {
        this.tableData = list
        this.pages.total = total
      }
    },
    stuHandleSizeChange(val) {
      this.pages.pageSize = val;
      this.pages.currentPage = 1;
      this.getReview()
    },
    stuHandleCurrentChange(val) {
      this.pages.currentPage = val;
      this.getReview()
    },
  }
}
</script>
<style lang="scss" scoped>
.main_right {
  width: calc(100% - 10.5vw);
  height: 100%;
  float: left;
  box-sizing: border-box;
  padding: 0 2%;
  position: relative;

  .page {
    position: absolute;
    bottom: 10px;
    right: 0;
  }

  .Box {
    width: 100%;
    height: 100%;
    box-shadow: 0px 0px 16px 0px rgba(89, 144, 255, 0.3);
    border-radius: 10px;
    padding: 2%;
    box-sizing: border-box;
    position: relative;

    .select {
      height: 2.5vw;
      width: 47vw;
      // background: #5990ff;
      background: #fff;
      box-sizing: border-box;
      border-radius: 4px;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
      padding: 0.25vw;
      margin-bottom: 1vw;

      p {
        float: right;
        width: 50%;
        height: 100%;
        background: #f1f8ff;
        font-size: 1vw;
        color: #333;
        text-align: center;
        line-height: 2vw;
        border: 1px solid rgb(220, 223, 230);
        border-radius: 4px;
      }
    }
  }

  .vocabulary {
    width: 30%;
    height: 3vw;
    float: left;

    div {
      width: 14vw;
      height: 3vw;
      background: #f1f8ff;
      border-radius: 10px;
      line-height: 3vw;
      box-sizing: border-box;
      padding: 0 3%;
      color: #333;

      span {
        display: block;
      }

      span:nth-child(1) {
        // display: block;
        font-size: 1.1vw;
        float: left;
      }

      p {
        float: right;

        span:nth-child(1) {
          font-size: 1.5vw;
          color: #409eff;
          font-weight: 600;
          float: left;
          margin-right: 1.5vw;
        }

        span:nth-child(2) {
          font-size: 1vw;
          float: left;
        }
      }
    }
  }

  .testpage {
    width: 100%;
    position: relative;

    p:nth-child(1) {
      width: 100%;
      height: 2.5vw;
      text-align: center;
      position: relative;
      color: #333;
      font-size: 1.5vw;
      line-height: 2.5vw;
    }
  }

  .table {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 1vw;
    top: 4vw;
  }

  .aRow {
    width: 100%;
    height: 3vw;
  }

  .aRow:after {
    /*伪元素是行内元素 正常浏览器清除浮动方法*/
    content: "";
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
  }

  .operation {
    display: inline-block;
    line-height: 2vw;
    width: 5vw;
    height: 2vw;
    font-size: 0.8vw;
    background: #e0eaff;
    box-shadow: 0px 0px 7px 1px rgba(89, 144, 255, 0.3);
    border-radius: 21px;
    color: #5990ff;
    cursor: pointer;
  }

  .selsectbox {
    width: 130px;
    // background: #fff;
    background: #f1f8ff;
    border-radius: 4px;
  }

  .exitpopup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2004;
  }

  .viewRresults {
    width: 30vw;
    height: 14.5vw;
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
    z-index: 2004;

    .title {
      width: 100%;
      height: 3vw;
      background: #5990ff;
      border-radius: 10px 10px 0 0;
      color: #fff;
      font-size: 1.3vw;
      text-align: center;
      line-height: 3vw;
    }

    .body {
      width: 100%;
      height: 8vw;
      box-sizing: border-box;
      padding: 1vw;
      display: flex;
      flex-direction: row;
      justify-content: space-around;

      .box {
        width: 30%;
        height: 100%;
        background: #eaf0fc;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding-top: 1vw;
        position: relative;

        p:nth-child(2) {
          position: absolute;
          top: 3.5vw;
          font-size: 1.1vw;
        }

        p:nth-child(1) {
          font-size: 1.7vw;
        }
      }
    }

    .footer {
      width: 100%;
      height: 3vw;
      display: flex;
      justify-content: center;
      align-items: center;

      p {
        width: 8vw;
        height: 2.3vw;
        background: #5990ff;
        border-radius: 25px;
        color: #fff;
        font-size: 1.2vw;
        text-align: center;
        line-height: 2.3vw;
        cursor: pointer;
      }
    }
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2001;
  }

  //自定义el-input框的一些自定义样式
  ::v-deep  .selsectbox .el-input--small .el-input__inner {
    // background-color: #e6f0ff;
    padding-left: 40px;
    height: 50px;
    border-radius: 5px;
    // color: #1890FF;
    font-size: 18px;
    border: 1px solid #1890ff;
    font-weight: 600;
  }

  //自定义左边图标
  // .selsectbox ::v-deep .el-input__inner{
  //   background: url('../../../assets/images/student/left.png') no-repeat center center; //引入icon
  //   background-size: 18px 18px;  //这个是图片的大小，在这里不能直接设置width  height,设置宽高其实是select的宽高，图片可能会失真只设置宽度  高度auto也行
  //   background-position:0.5vw 50%; //在input中定位置  可以调整自定义icon的左右上下位置
  //   padding: 0 0 0 2.5vw; //需要设置padding 把placeholder向右移
  //   box-sizing: border-box;
  //   font-size: 14px;
  // }
  //替换右边边默认图标
  ::v-deep  .selsectbox .el-icon-arrow-up::before {
    content: "";
    background: url("../../../assets/images/student/triangle.png") center center no-repeat;
    position: absolute;
    background-size: 18px 12px;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(180deg);
  }

  ::v-deep  .selsectbox .el-input--small input::-webkit-input-placeholder {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 550;
    // color: #2881FF;
  }
}

/* ========== 手机端适配样式 ========== */
@media screen and (max-width: 768px) {
  .main_right {
    width: calc(100% - 80px);
    padding: 0 10px;

    .Box {
      padding: 12px 10px;
      display: flex;
      flex-direction: column;
      height: auto;
      min-height: 100%;

      ::v-deep  .el-input .el-input__inner {
        height: 5vh !important;
        font-size: 12px;
      }

      ::v-deep  .el-input .el-input__icon {
        width: 30px !important;
        padding-top: 3px;
      }

      .el-date-picker {
        width: 100% !important;
        margin-bottom: 15px;

        ::v-deep  .el-input__inner {
          height: 40px;
          line-height: 40px;
          font-size: 13px;
        }
      }
    }

    .testpage {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: hidden;

      p:nth-child(1) {
        height: 36px;
        line-height: 36px;
        font-size: 14px;
        flex-shrink: 0;
        text-align: center;
      }

      .table {
        position: relative;
        top: auto;
        bottom: auto;
        flex: 1;
        overflow: auto;
        width: 100%;

        ::v-deep  .el-table__body-wrapper {
          overflow-x: auto;
        }

        ::v-deep  .el-table__header {
          width: 100%;
        }

        ::v-deep  .el-table__body {
          width: 100%;
        }
      }
    }

    .page {
      position: relative;
      bottom: auto;
      right: auto;
      margin-top: 15px;
      display: flex;
      justify-content: flex-end;

      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 8px;
        }

        .el-pager li {
          min-width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 12px;
        }

        .el-pagination__total {
          font-size: 12px;
        }

        .el-pagination__sizes {
          .el-select .el-input__inner {
            font-size: 12px;
            height: 28px;
            line-height: 28px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .main_right {
    width: calc(100% - 65px);
    padding: 0 8px;

    .Box {
      padding: 10px 8px;

      ::v-deep  .el-input .el-input__inner {
        height: 5vh !important;
        font-size: 12px;
      }

      ::v-deep  .el-input .el-input__icon {
        width: 30px !important;
        padding-top: 3px;
      }

      .el-date-picker ::v-deep  .el-input__inner {
        height: 36px;
        font-size: 12px;
      }
    }

    .testpage p:nth-child(1) {
      height: 32px;
      line-height: 32px;
      font-size: 13px;
    }

    .page {
      ::v-deep  .el-pagination {
        .btn-prev, .btn-next {
          padding: 0 6px;
          min-width: 28px;
        }

        .el-pager li {
          min-width: 24px;
          height: 24px;
          line-height: 24px;
          font-size: 11px;
        }

        .el-pagination__total {
          font-size: 11px;
        }

        .el-pagination__sizes .el-select .el-input__inner {
          font-size: 11px;
          height: 24px;
          line-height: 24px;
        }
      }
    }
  }
}
</style>
